export default {
  WEEEQuestion: 'WEEE FAQ',
  PACKAGINGQuestion: 'Verpackungsgesetz FAQ',
  BATTERYQuestion: 'Batteriegesetz FAQ',
  EPRQuestion: 'EPR FAQ',
}